export type SettingId = string;

export class SettingDescription<T> {
    id: SettingId;
    description: string;
    tooltip: string;
    defaultValue: T;
    isExperimental: boolean;

    constructor(raw: { id: string, description: string, tooltip: string, defaultValue: T , isExperimental: boolean}) {
        this.id = raw.id;
        this.description = raw.description;
        this.tooltip = raw.tooltip;
        this.defaultValue = raw.defaultValue;
        this.isExperimental = raw.isExperimental;
    }
}

export const ExperimentalSettingTooltip = "Experimental feature! Please report any bugs.";

export class SettingValue<T> {
    id: SettingId;
    value: T;

    constructor(raw: { id: SettingId, value: T }, description: SettingDescription<T>) {
        this.id = raw.id;
        if (raw.value !== undefined && raw.value !== null) {
            this.value = raw.value;
        } else {
            this.value = description.defaultValue
        }
    }

    getValue(): T {
        return this.value;
    }
    setValue(newVal: T) {
        this.value = newVal;
    }
}

export type SettingBankDefinition = { [index: SettingId]: SettingDescription<any> };

// THere is a question of whether we should be saving the settings at all, but I think we should.
export class SettingsBank<Type> {
    values;

    constructor(rawSettings: { [index: SettingId]: SettingValue<any> }, bankDefinition: SettingBankDefinition) {
        this.values = {};
        Object.values(rawSettings).forEach(setting => {
            // TODO BL: This is obviously not going to work with more setting types, but we'll manage
            this.values[setting.id] = new SettingValue<boolean>({ id: setting.id, value: setting.value }, bankDefinition[setting.id]);
        })
        Object.values(bankDefinition).forEach(description => {
            if (!this.values[description.id]) {
                this.values[description.id] = new SettingValue<boolean>({ id: description.id, value: description.defaultValue }, bankDefinition[description.id]);
            }
        })
    }

    setValue<T>(setting: SettingId, value: T) {
        this.values[setting].setValue(value);
    }
    getValue<T>(setting: SettingId): T {
        return this.values[setting].getValue();
    }

    public static default<Type>(definition: SettingBankDefinition): SettingsBank<Type> {
        let initialData: any = {};

        Object.entries(definition).forEach(entry => {
            const key = entry[0];
            const description = entry[1];
            // TODO BL: This is obviously not going to work with more setting types, but we'll manage
            initialData[key] = new SettingValue<boolean>({ id: description.id, value: description.defaultValue }, description);
        });
        return new SettingsBank(
            initialData,
            definition,
        );
    }
}